import { render, staticRenderFns } from "./ReporteEmisionesAIGFallidas.vue?vue&type=template&id=56b30c19"
import script from "./ReporteEmisionesAIGFallidas.vue?vue&type=script&lang=js"
export * from "./ReporteEmisionesAIGFallidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports